import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Auth.css';
import { MIN_PASSWORD_LENGTH, PASSWORD_MIN_LENGTH_MESSAGE, PASSWORD_PLACEHOLDER } from '../utils/passwordPolicy';
import { api } from '../api';

const Cadastro = () => {
  const [formData, setFormData] = useState({
    email: '',
    cpf: '',
    nome_completo: '',
    senha: '',
    confirmar_senha: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Validações
    if (!formData.email || !formData.cpf || !formData.nome_completo || !formData.senha || !formData.confirmar_senha) {
      setError('Todos os campos são obrigatórios');
      setLoading(false);
      return;
    }

    if (formData.senha !== formData.confirmar_senha) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    if (formData.senha.length < MIN_PASSWORD_LENGTH) {
      setError(PASSWORD_MIN_LENGTH_MESSAGE);
      setLoading(false);
      return;
    }

    if (formData.cpf.length !== 11 || !/^\d+$/.test(formData.cpf)) {
      setError('CPF deve conter exatamente 11 dígitos');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/api/auth/cadastro-publico', {
        email: formData.email,
        cpf: formData.cpf,
        nome_completo: formData.nome_completo,
        senha: formData.senha,
        confirmar_senha: formData.confirmar_senha,
      });

      setSuccess('Cadastro realizado com sucesso! Redirecionando para login...');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erro ao criar conta. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card cadastro-card">
        <div className="auth-header">
          <h1>Novo Cadastro</h1>
          <p>Crie sua conta no FisiSaaS</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="nome_completo">Nome Completo</label>
            <input
              type="text"
              id="nome_completo"
              name="nome_completo"
              value={formData.nome_completo}
              onChange={handleChange}
              placeholder="Seu nome completo"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="seu@email.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="cpf">CPF</label>
            <input
              type="text"
              id="cpf"
              name="cpf"
              value={formData.cpf}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                setFormData((prev) => ({
                  ...prev,
                  cpf: value,
                }));
              }}
              placeholder="00000000000"
              maxLength="11"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <div className="password-input-group">
              <input
                type={showPassword ? 'text' : 'password'}
                id="senha"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                placeholder={PASSWORD_PLACEHOLDER}
                required
                disabled={loading}
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="confirmar_senha">Confirmar Senha</label>
            <input
              type={showPassword ? 'text' : 'password'}
              id="confirmar_senha"
              name="confirmar_senha"
              value={formData.confirmar_senha}
              onChange={handleChange}
              placeholder="Digite a senha novamente"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Criando conta...' : 'Criar Conta'}
          </button>
        </form>

        <div className="auth-links">
          <span>Já possui conta?</span>
          <Link to="/login" className="link">
            Faça login
          </Link>
        </div>

        <div className="auth-footer">
          <p>© 2026 FisiSaaS. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default Cadastro;
